export const selectPhoneData = (state) => state.phone;

